import Vue from "vue";
import VueRouter from "vue-router";
import Meta from "vue-meta";

import VueBodyClass from "vue-body-class";

Array.from(document.querySelectorAll("meta[remove]"))
  .concat([document.querySelector("title")])
  .map((meta) => {
    meta.remove();
  });

Vue.use(VueRouter);
Vue.use(Meta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  tagIDKeyName: "vmid",
  refreshOnceOnNavigation: true,
});

function lazyLoad(module, view) {
  return () => import(`../views/modules/${module}/pages/${view}`);
}

const defaultRoutes = [
  {
    path: "/reset-password",
    redirect: "/app/reset-password/new",
  },
  {
    path: "/app",
    redirect: "/",
    component: () => import("Container/AuthLayout"),
    children: [
      {
        path: "/app/login",
        redirect: "/",
      },
      {
        path: "/app/reset-password",
        redirect: "/",
      },
      {
        path: "/app/reset-password/new",
        meta: {
          requiresAuth: false,
          skipModuleCheck: true,
        },
        component: lazyLoad("general", "NewPassword"),
      },
    ],
  },

  {
    path: "/user/agreement",
    meta: {
      requiresAuth: false,
      skipModuleCheck: true,
    },
    component: lazyLoad("general", "UserAgreement"),
  },

  {
    path: "/",
    meta: {
      requiresAuth: false,
      skipModuleCheck: true,
    },
    // redirect: "/",
    // alias: "/homepage",
    component: () => import("Container/BaseLayout"),
    children: [
      {
        path: "/",
        meta: {
          requiresAuth: false,
          skipModuleCheck: true,
          showBottomAuthBanner: false,
          metaInfo: "home",
        },

        component: lazyLoad("general", "Home"),
      },
      {
        path: "/subscriptions",
        meta: {
          requiresAuth: true,
          skipModuleCheck: true,
        },
        component: lazyLoad("general", "Subscriptions"),
      },
      {
        path: "/account",
        meta: {
          requiresAuth: true,
          skipModuleCheck: true,
        },
        component: lazyLoad("general", "LK"),
      },
    ],
  },
  {
    path: "/homepage",
    meta: {
      requiresAuth: false,
      skipModuleCheck: true,
    },
    redirect: () => {
      // the function receives the target route as the argument
      // we return a redirect path/location here.
      return { path: "/" };
    },
  },
  {
    path: "/AI",
    meta: {
      requiresAuth: false,
    },
    redirect: "/AI/services",
    alias: "/services",
    component: () => import("Container/BaseLayout"),
    children: [
      {
        path: "/AI/services",
        alias: "/services",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "ai-services",
        },
        component: lazyLoad("AI", "Services"),
      },
      {
        path: "/AI/calc",
        alias: "/calc",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "custom",
        },
        component: lazyLoad("AI", "Calc"),
      },
      {
        path: "/AI/studies",
        alias: "/studies",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          authBannerText: "Auth banner text 2",
          metaInfo: "custom",
        },
        component: lazyLoad("AI", "Studies"),
      },
      {
        path: "/AI/geotar_clinguide",
        meta: {
          accessInstallations: "ru",
        },
        component: lazyLoad("AI", "Geotar"),
      },
    ],
  },
  {
    path: "/edu",
    meta: {
      requiresAuth: false,
      accessInstallations: "ru",
    },
    redirect: "/edu/services",
    component: () => import("Container/BaseLayout"),
    children: [
      {
        path: "/edu/schools",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "edu-schools",
        },
        component: lazyLoad("edu", "Schools"),
      },
      {
        path: "/edu/schools/:schoolId",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "custom",
        },
        component: lazyLoad("edu", "School"),
      },
      {
        path: "/edu/universities",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "edu-universities",
        },
        component: lazyLoad("edu", "Universities"),
      },
      {
        path: "/edu/universities/:universityId",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "custom",
        },
        component: lazyLoad("edu", "University"),
      },
      {
        path: "/edu/services",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "edu-services",
        },
        component: lazyLoad("edu", "Services"),
      },
      {
        path: "/edu/services/:serviceId/lessons",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "custom",
        },
        component: lazyLoad("edu", "Lessons"),
      },
      {
        path: "/edu/services/:serviceId/lessons/:lessonId/studies",
        meta: {
          requiresAuth: false,
          metaInfo: "custom",
        },
        component: lazyLoad("edu", "Cases"),
      },
      {
        path: "/edu/services/:serviceId/lessons/:lessonId/quiz/:quizId",
        meta: {
          requiresAuth: true,
          skipModuleCheck: true,
        },
        component: lazyLoad("general", "Quiz"),
      },
      {
        path: "/edu/services/:serviceId/lessons/:lessonId/quiz/:quizId/review",
        meta: {
          requiresAuth: true,
          skipModuleCheck: true,
        },
        component: lazyLoad("general", "QuizReview"),
      },
    ],
  },
  {
    path: "/community",
    meta: {
      requiresAuth: false,
      accessInstallations: "ru",
    },
    redirect: "/community/cases",
    component: () => import("Container/BaseLayout"),
    children: [
      {
        path: "/community/cases",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "community-cases",
        },
        component: lazyLoad("community", "Cases"),
      },
      {
        path: "/community/cases/:caseId",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "custom",
        },
        component: lazyLoad("community", "Case"),
      },
      {
        path: "/community/cases/:caseId/editing",
        meta: {
          requiresAuth: true,
          metaInfo: "custom",
        },
        component: lazyLoad("community", "EditingCase"),
      },
    ],
  },

  {
    path: "*",
    redirect: "/AI/404",
    component: () => import("Container/BaseLayout"),
    children: [
      {
        path: "/AI/404",
        component: lazyLoad("general", "PageNotFound"),
      },
    ],
  },
];

const createRouter = () =>
  new VueRouter({
    mode: "history",
    routes: defaultRoutes.filter((route) => {
      return (
        !route.meta?.accessInstallations ||
        route.meta.accessInstallations.indexOf(
          process.env.VUE_APP_INSTALLATION
        ) !== -1
      );
    }),
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

const router = createRouter();

const vueBodyClass = new VueBodyClass(defaultRoutes);
router.beforeEach((to, from, next) => {
  vueBodyClass.guard(to, next);
});

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // the relevant part
}

export default router;
